"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryFunc = exports.QueryPart = exports.PartArgument = void 0;
var jokenizer_1 = require("jokenizer");
var PartArgument = /** @class */ (function () {
    // tslint:enable:variable-name
    // tslint:disable-next-line:ban-types
    function PartArgument($identifier, $literal, scopes) {
        if (typeof $identifier === "string") {
            this._expStr = $identifier;
        }
        else {
            this._func = $identifier;
        }
        this._literal = $literal;
        this._scopes = scopes;
    }
    // tslint:disable-next-line:ban-types
    PartArgument.identifier = function (value, scopes) {
        return new PartArgument(value, null, scopes);
    };
    PartArgument.literal = function (value) {
        return new PartArgument(null, value, null);
    };
    Object.defineProperty(PartArgument.prototype, "func", {
        get: function () {
            var _this = this;
            if (this._func) {
                return this._func;
            }
            if (!this._expStr) {
                return null;
            }
            if (this.exp.type === "Func" /* Func */) {
                var f_1 = jokenizer_1.evaluate.apply(void 0, __spread([this.exp], this._scopes));
                return this._func = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return f_1.apply(null, args);
                };
            }
            return this._func = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return jokenizer_1.evaluate.apply(void 0, __spread([_this.exp], args.concat(_this._scopes)));
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartArgument.prototype, "expStr", {
        get: function () {
            if (this._expStr) {
                return this._expStr;
            }
            if (!this._func) {
                return null;
            }
            return this._expStr = this._func.toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartArgument.prototype, "exp", {
        get: function () {
            if (this._exp) {
                return this._exp;
            }
            var s = this.expStr;
            if (!s) {
                return null;
            }
            return this._exp = jokenizer_1.tokenize(s);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartArgument.prototype, "literal", {
        get: function () {
            return this._literal;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PartArgument.prototype, "scopes", {
        get: function () {
            return this._scopes;
        },
        enumerable: false,
        configurable: true
    });
    return PartArgument;
}());
exports.PartArgument = PartArgument;
// tslint:disable-next-line:ban-types
function identifier(value, scopes) {
    return PartArgument.identifier(value, scopes);
}
function literal(value) {
    return PartArgument.literal(value);
}
// tslint:disable-next-line:max-classes-per-file
var QueryPart = /** @class */ (function () {
    // tslint:enable:variable-name
    function QueryPart(type, args, scopes) {
        if (args === void 0) { args = []; }
        if (scopes === void 0) { scopes = []; }
        if (!type) {
            throw new Error("Type of QueryPart cannot be null or empty.");
        }
        this._type = type;
        this._args = args;
        this._type = type;
        this._scopes = scopes;
    }
    QueryPart.create = function (type, args, scopes) {
        return new QueryPart(type, args, scopes);
    };
    QueryPart.aggregate = function (func, seed, scopes) {
        return this.create(exports.QueryFunc.aggregate, [identifier(func, scopes), literal(seed)], scopes);
    };
    QueryPart.all = function (predicate, scopes) {
        return this.create(exports.QueryFunc.all, [identifier(predicate, scopes)], scopes);
    };
    QueryPart.any = function (predicate, scopes) {
        return this.create(exports.QueryFunc.any, [identifier(predicate, scopes)], scopes);
    };
    QueryPart.average = function (selector, scopes) {
        return this.create(exports.QueryFunc.average, [identifier(selector, scopes)], scopes);
    };
    QueryPart.cast = function (type) {
        return this.create(exports.QueryFunc.cast, [literal(type)]);
    };
    QueryPart.concat = function (other) {
        return this.create(exports.QueryFunc.concat, [literal(other)]);
    };
    QueryPart.contains = function (item, comparer, scopes) {
        return this.create(exports.QueryFunc.contains, [literal(item), identifier(comparer, scopes)]);
    };
    QueryPart.count = function (predicate, scopes) {
        return this.create(exports.QueryFunc.count, [identifier(predicate, scopes)], scopes);
    };
    QueryPart.defaultIfEmpty = function (defaultValue) {
        return this.create(exports.QueryFunc.defaultIfEmpty, [literal(defaultValue)]);
    };
    QueryPart.distinct = function (comparer, scopes) {
        return this.create(exports.QueryFunc.distinct, [identifier(comparer, scopes)], scopes);
    };
    QueryPart.elementAt = function (index) {
        return this.create(exports.QueryFunc.elementAt, [literal(index)]);
    };
    QueryPart.elementAtOrDefault = function (index) {
        return this.create(exports.QueryFunc.elementAtOrDefault, [literal(index)]);
    };
    QueryPart.except = function (other, comparer, scopes) {
        return this.create(exports.QueryFunc.except, [literal(other), identifier(comparer, scopes)], scopes);
    };
    QueryPart.first = function (predicate, scopes) {
        return this.create(exports.QueryFunc.first, [identifier(predicate, scopes)], scopes);
    };
    QueryPart.firstOrDefault = function (predicate, scopes) {
        return this.create(exports.QueryFunc.firstOrDefault, [identifier(predicate, scopes)], scopes);
    };
    QueryPart.groupBy = function (keySelector, elementSelector, scopes) {
        return this.create(exports.QueryFunc.groupBy, [identifier(keySelector, scopes), identifier(elementSelector, scopes)], scopes);
    };
    QueryPart.groupJoin = function (other, thisKey, otherKey, selector, scopes) {
        return this.createJoin(exports.QueryFunc.groupJoin, other, thisKey, otherKey, selector, scopes);
    };
    QueryPart.inlineCount = function () {
        return this.create(exports.QueryFunc.inlineCount, [literal(true)]);
    };
    QueryPart.intersect = function (other, comparer, scopes) {
        return this.create(exports.QueryFunc.intersect, [literal(other), identifier(comparer, scopes)], scopes);
    };
    QueryPart.join = function (other, thisKey, otherKey, selector, scopes) {
        return this.createJoin(exports.QueryFunc.join, other, thisKey, otherKey, selector, scopes);
    };
    QueryPart.last = function (predicate, scopes) {
        return this.create(exports.QueryFunc.last, [identifier(predicate, scopes)], scopes);
    };
    QueryPart.lastOrDefault = function (predicate, scopes) {
        return this.create(exports.QueryFunc.lastOrDefault, [identifier(predicate, scopes)], scopes);
    };
    QueryPart.max = function (selector, scopes) {
        return this.create(exports.QueryFunc.max, [identifier(selector, scopes)], scopes);
    };
    QueryPart.min = function (selector, scopes) {
        return this.create(exports.QueryFunc.min, [identifier(selector, scopes)], scopes);
    };
    QueryPart.ofGuardedType = function (typeGuard) {
        return this.create(exports.QueryFunc.ofGuardedType, [literal(typeGuard)]);
    };
    QueryPart.ofType = function (type) {
        return this.create(exports.QueryFunc.ofType, [literal(type)]);
    };
    QueryPart.orderBy = function (keySelector, scopes) {
        return this.create(exports.QueryFunc.orderBy, [identifier(keySelector, scopes)], scopes);
    };
    QueryPart.orderByDescending = function (keySelector, scopes) {
        return this.create(exports.QueryFunc.orderByDescending, [identifier(keySelector, scopes)], scopes);
    };
    QueryPart.reverse = function () {
        return this.create(exports.QueryFunc.reverse);
    };
    QueryPart.select = function (selector, scopes) {
        return this.create(exports.QueryFunc.select, [identifier(selector, scopes)], scopes);
    };
    QueryPart.selectMany = function (selector, scopes) {
        return this.create(exports.QueryFunc.selectMany, [identifier(selector, scopes)], scopes);
    };
    QueryPart.sequenceEqual = function (other, comparer, scopes) {
        return this.create(exports.QueryFunc.sequenceEqual, [literal(other), identifier(comparer, scopes)], scopes);
    };
    QueryPart.single = function (predicate, scopes) {
        return this.create(exports.QueryFunc.single, [identifier(predicate, scopes)], scopes);
    };
    QueryPart.singleOrDefault = function (predicate, scopes) {
        return this.create(exports.QueryFunc.singleOrDefault, [identifier(predicate, scopes)], scopes);
    };
    QueryPart.skip = function (count) {
        return this.create(exports.QueryFunc.skip, [literal(count)]);
    };
    QueryPart.skipWhile = function (predicate, scopes) {
        return this.create(exports.QueryFunc.skipWhile, [identifier(predicate, scopes)], scopes);
    };
    QueryPart.sum = function (selector, scopes) {
        return this.create(exports.QueryFunc.sum, [identifier(selector, scopes)], scopes);
    };
    QueryPart.take = function (count) {
        return this.create(exports.QueryFunc.take, [literal(count)]);
    };
    QueryPart.takeWhile = function (predicate, scopes) {
        return this.create(exports.QueryFunc.takeWhile, [identifier(predicate, scopes)], scopes);
    };
    QueryPart.thenBy = function (keySelector, scopes) {
        return this.create(exports.QueryFunc.thenBy, [identifier(keySelector, scopes)], scopes);
    };
    QueryPart.thenByDescending = function (keySelector, scopes) {
        return this.create(exports.QueryFunc.thenByDescending, [identifier(keySelector, scopes)], scopes);
    };
    QueryPart.union = function (other, comparer, scopes) {
        return this.create(exports.QueryFunc.union, [literal(other), identifier(comparer, scopes)], scopes);
    };
    QueryPart.where = function (predicate, scopes) {
        return this.create(exports.QueryFunc.where, [identifier(predicate, scopes)], scopes);
    };
    QueryPart.zip = function (other, selector, scopes) {
        return this.create(exports.QueryFunc.zip, [literal(other), identifier(selector, scopes)], scopes);
    };
    QueryPart.toArray = function () {
        return this.create(exports.QueryFunc.toArray);
    };
    QueryPart.createJoin = function (type, other, thisKey, otherKey, selector, scopes) {
        return this.create(type, [
            literal(other),
            identifier(thisKey, scopes),
            identifier(otherKey, scopes),
            identifier(selector, scopes),
        ], scopes);
    };
    Object.defineProperty(QueryPart.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryPart.prototype, "args", {
        get: function () {
            return this._args;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QueryPart.prototype, "scopes", {
        get: function () {
            return this._scopes;
        },
        enumerable: false,
        configurable: true
    });
    return QueryPart;
}());
exports.QueryPart = QueryPart;
exports.QueryFunc = {
    aggregate: "aggregate",
    all: "all",
    any: "any",
    average: "average",
    cast: "cast",
    concat: "concat",
    contains: "contains",
    count: "count",
    defaultIfEmpty: "defaultIfEmpty",
    distinct: "distinct",
    elementAt: "elementAt",
    elementAtOrDefault: "elementAtOrDefault",
    except: "except",
    first: "first",
    firstOrDefault: "firstOrDefault",
    groupBy: "groupBy",
    groupJoin: "groupJoin",
    inlineCount: "inlineCount",
    intersect: "intersect",
    join: "join",
    last: "last",
    lastOrDefault: "lastOrDefault",
    max: "max",
    min: "min",
    ofGuardedType: "ofGuardedType",
    ofType: "ofType",
    orderBy: "orderBy",
    orderByDescending: "orderByDescending",
    reverse: "reverse",
    select: "select",
    selectMany: "selectMany",
    sequenceEqual: "sequenceEqual",
    single: "single",
    singleOrDefault: "singleOrDefault",
    skip: "skip",
    skipWhile: "skipWhile",
    sum: "sum",
    take: "take",
    takeWhile: "takeWhile",
    thenBy: "thenBy",
    thenByDescending: "thenByDescending",
    toArray: "toArray",
    union: "union",
    where: "where",
    zip: "zip",
};
//# sourceMappingURL=query-part.js.map